import { sample } from 'effector';
import { $pathname } from '@features/common';
import {
  fxCreateSduiTicket,
  fxGetCustomFieldsSduiJson,
  fxUpdateSduiTicket,
  getCustomFieldsSduiJson,
} from '../../detail-sdui/model';
import { closeDetail, path, updateTicketList } from '../../page/page.model';
import { fxNotifySupport } from '../../ticket';
import { $openedId, setOpenedId } from '../model';

/** Только для раздела tickets */
export const outerEvents = () => {
  /** При ошибке запроса заявки, закрываю детали */
  sample({
    clock: fxGetCustomFieldsSduiJson.fail,
    source: $pathname,
    filter: (pathname) => `/${pathname.split('/')[1]}` === path,
    target: closeDetail,
  });

  /** После успешного создания заявки перехожу в нее и обновляю таблицу */
  sample({
    clock: fxCreateSduiTicket.doneData,
    source: $pathname,
    filter: (pathname) => `/${pathname.split('/')[1]}` === path,
    fn: (_, { ticket }) => ticket.id,
    target: [setOpenedId, updateTicketList],
  });

  /** После успешного обновления заявки обновляю таблицу */
  sample({
    clock: fxUpdateSduiTicket.done,
    target: updateTicketList,
  });

  /** После успешного создания чата техподдержки, обновляю тикет */
  sample({
    clock: fxNotifySupport.done,
    source: { openedId: $openedId, pathname: $pathname },
    filter: ({ openedId, pathname }) => {
      if (`/${pathname.split('/')[1]}` !== path) return false;

      if (!openedId) return false;

      return localStorage.getItem('ticketsNewVersion') === 'new';
    },
    fn: ({ openedId }) => ({ openedId: openedId! }),
    target: getCustomFieldsSduiJson,
  });
};
